import heroPortrait from '../assets/homepage/hero-portrait.jpg';

export const homeHero = {
  eyebrow: 'Hola Soy',
  name: 'Emmanuel Muñoz Blanco',
  tagline: 'Designing thoughtful interactions, grounded in research and brought to life through code. CS @ Georgia Tech · People + Media',
  portrait: heroPortrait,
};

export const currentRoles = [
  {
    id: 'teaching-assistant',
    title: 'Head Teaching Assistant',
    organization: 'CS 2340',
    since: 'Since August 2024',
    icon: 'assistant',
    summary:
      "I have worked under Dr. Feijoo-Garcia's CS 2340 class for over two years. I mentor students on good software development practices. I am also responsible for ensuring accuracy for the gradebook of over 500 students, handling regrades in a timely manner, and standardizing the feedback provided by the instructional team.",
  },
  {
    id: 'research',
    title: 'Undergraduate Research',
    organization: 'PARCE Lab',
    since: 'Since August 2024',
    icon: 'research',
    summary:
      'At PARCE Lab, I co-authored 5 papers that combine software systems with human-centered interaction research, including work around how professional experiences influence the imposter phenomenon and self-efficacy (Frontiers In Education), using student-designed AI agents as a learning technique (ASEE), and vocalics in AI agents (Frontiers).',
  },
  {
    id: 'merchandiser',
    title: 'Distribution Merchandiser',
    organization: 'EMCA Foods LLC',
    since: 'Since April 2020',
    icon: 'retail',
    summary:
      "My family's business gave me hands-on experience in retail operations, bilingual communication, sales growth, negotiation with store managers, and making deliveries more efficient across the Metro Atlanta area. I've helped grow sales over 100% in the span of 5 years.",
  },
];

export const skillPills = [
  'JavaScript',
  'TypeScript',
  'React',
  'Java',
  'Python',
  'UX Research',
  'Human-Centered AI',
  'Persona Creation',
  'Conflict Resolution',
  'Qualitative Research',
  'Quantitative Research',
  'Scrum Development Cycle',
  'Interdiscplinary Communication'
];
